import React, { memo, useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Component
import UnreadText from '../../../components/UnreadText/UnreadText'
import PageTitle from '../../../components/PageTitle'
import TableComponent from '../../../components/Common/TableComponent'
// Layout
import BoardReportLayout from '../BoardReportLayout.js'
// styled Component
import {
  TableActionWrapper,
  TableFooterActionWrapper,
  TextRich,
} from './BoardReportPageStyled'
// Ant design
import { Button, Empty, Pagination } from 'antd'
//other
import { inject, observer } from 'mobx-react'
import { useLocation, withRouter } from 'react-router-dom'
import moment from 'moment'
import { ACL_ACTION_TYPE, DATE_FORMAT_DEFAULT } from '../../../constants'
import queryString from 'query-string'
import AccessControlAction from '../../../components/AccessControlAction'
import { PlusOutlined } from '@ant-design/icons'
import BoardReportCreateModal from '../BoardReportCreate/BoardReportCreateModal'
import AdvanceFilterBlockBoardReport from './AdvanceFilterBlockBoardReport'
import { AvatarHasName } from '../../../components/Common/Avatar'

const BoardReportPage = props => {
  const { history, loadingAnimationStore, boardReportStore, userStore } = props

  const {
    boardReportList,
    boardReportTotalCount,
    queryParams,
  } = boardReportStore

  const { userList } = userStore

  const [isVisibleCreateModal, setIsVisibleCreateModal] = useState(false)
  const location = useLocation()
  const queryStringParse = queryString.parse(location.search)
  const [isRefreshPage, setIsRefreshPage] = useState(true)
  const [isInitialized, setIsInitialized] = useState(false)

  const TIEU_DE_WIDTH = 600
  const NGAY_TAO_WIDTH = 120
  const NGUOI_TAO_WIDTH = 120
  const SCROLL_WIDTH = 1000

  const formatName = name => {
    if (!name || typeof name !== 'string') return ''
    return name
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  const tableColumns = useMemo(
    () => [
      {
        title: 'Tiêu đề',
        width: TIEU_DE_WIDTH,
        render: record => (
          <UnreadText text={record.title} width={TIEU_DE_WIDTH} />
        ),
      },
      {
        title: 'Ngày tạo',
        width: NGAY_TAO_WIDTH,
        render: record => (
          <UnreadText
            text={moment(record.created_at).format(DATE_FORMAT_DEFAULT)}
            width={NGAY_TAO_WIDTH}
          />
        ),
      },
      {
        title: 'Người tạo',
        width: NGUOI_TAO_WIDTH,
        render: record => {
          const userCreated = record.user_created

          return (
            <UnreadText
              text={
                <div className="user">
                  {userCreated ? (
                    <AvatarHasName
                      imgId={userCreated.image_id}
                      name={formatName(
                        userCreated.name_lowercase || userCreated.user_name
                      )}
                    />
                  ) : (
                    <span
                      style={{
                        color: 'rgba(146, 142, 142, 0.8)',
                        display: 'inline-block',
                        minWidth: '70px',
                        fontStyle: 'italic',
                      }}>
                      Không có.
                    </span>
                  )}
                </div>
              }
              width={NGUOI_TAO_WIDTH}
            />
          )
        },
      },
    ],
    []
  )

  const onChangePagination = pageIndex => {
    boardReportStore.setQueryParams({
      ...queryParams,
      page: pageIndex - 1,
      size: 10,
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        page: pageIndex - 1,
        size: 10,
      },
      {
        skipNull: true,
      }
    )
    history.replace(`/board-report?${queryStringStringify}`)
  }

  const getBoardReportList = async () => {
    try {
      loadingAnimationStore.setTableLoading(true)
      await boardReportStore.getBoardReportList()

      const keyword = (queryParams.content || '').toLowerCase().trim()
      if (keyword) {
        const filteredList = boardReportStore.boardReportList.filter(item => {
          const plainText = stripHtml(item.content).toLowerCase()
          return plainText.includes(keyword)
        })

        boardReportStore.boardReportList = filteredList
      }
    } catch (error) {
      console.log(error)
    } finally {
      loadingAnimationStore.setTableLoading(false)
    }
  }

  useEffect(() => {
    boardReportStore.setQueryParams({
      ...queryParams,
      ...queryStringParse,
    })
    ;(async () => {
      try {
        loadingAnimationStore.setTableLoading(true)
        await getBoardReportList()
        setIsRefreshPage(false)
        setIsInitialized(true)
      } catch (err) {
        console.log(err)
      } finally {
        loadingAnimationStore.setTableLoading(false)
      }
    })()

    return () => {
      boardReportStore.clearBoardReportList()
      boardReportStore.clearQueryParams()
    }
  }, [])

  useEffect(() => {
    if (isRefreshPage || !isInitialized) return
    ;(async () => {
      await getBoardReportList()
    })()
  }, [queryParams, isInitialized])

  useEffect(() => {
    if (!userList || userList.length === 0) {
      userStore.getUserListV2()
    }
  }, [])

  return (
    <>
      <BoardReportLayout
        title={
          <PageTitle location={props.location} title="Văn bản đến" hiddenGoBack>
            <Button
              icon={<PlusOutlined />}
              onClick={e => {
                e.currentTarget.blur()
                setIsVisibleCreateModal(true)
              }}
              type="primary">
              Tạo mới
            </Button>
          </PageTitle>
        }>
        <Helmet>
          <title>Báo cáo HĐQT</title>
        </Helmet>
        <TableActionWrapper>
          <div style={{ marginBottom: 24 }}>
            <AdvanceFilterBlockBoardReport
              userList={userList}
            />
          </div>

          <TableComponent
            onRow={record => {
              return {
                onClick: () => history.push(`/board-report/${record.code}`),
              }
            }}
            rowKey={record => record.id}
            dataSource={boardReportList}
            columns={tableColumns}
            pagination={false}
            scroll={{ x: SCROLL_WIDTH }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={'Không có dữ liệu'}
                />
              ),
            }}
            loading={{
              tip: 'Đang tải báo cáo...',
              spinning: loadingAnimationStore.tableLoading,
            }}
          />
          <TableFooterActionWrapper>
            <Pagination
              onChange={onChangePagination}
              total={boardReportTotalCount}
              pageSize={queryParams.size}
              current={queryParams.page + 1}
              showSizeChanger={false}
              showLessItems
            />
          </TableFooterActionWrapper>
        </TableActionWrapper>
      </BoardReportLayout>

      <BoardReportCreateModal
        visible={isVisibleCreateModal}
        onCancel={() => setIsVisibleCreateModal(false)}
        onSuccess={() => getBoardReportList()}
      />
    </>
  )
}

export default memo(
  withRouter(
    inject(
      'boardReportStore',
      'userStore',
      'loadingAnimationStore'
    )(observer(BoardReportPage))
  )
)
